import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export interface Pagination {
  hasNext: boolean;
  hasPrev: boolean;
  nextNum: number | null;
  page: number;
  pages: number;
  perPage: number;
  total: number;
}

export interface AsyncMessageArchiveResponse {
  asyncMessages: AsyncMessageItem[];
  pagination?: Pagination | null;
}

export interface AsyncMessageItem {
  message: AsyncMessageMessageData;
  patient: AsyncMessagePatientData;
  encounter: AsyncMessageEncounterData;
}

export interface AsyncMessageMessageData {
  archived: true;
  messageBody: string;
  notificationId: number;
  receivedAt: string;
  slaEndedAt: string;
  unread: boolean;
}

export interface AsyncMessagePatientData {
  addressState: string;
  administrativeGender: string;
  age: number;
  dob: string;
  genderIdentity: string;
  id: string;
  isPeds: boolean;
  nameFirst: string;
  nameLast: string;
  partnerUids: string[];
  preferredPartnerUid?: string | null;
}

export interface AsyncMessageEncounterData {
  ownAsyncEncounterId?: string;
}

export const DEFAULT_ASYNC_MESSAGE_ARCHIVE_PER_PAGE = 25;

export const useAsyncMessageArchive = ({
  page,
  perPage = DEFAULT_ASYNC_MESSAGE_ARCHIVE_PER_PAGE,
  enabled = true,
}: {
  page: number;
  perPage?: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryFn: async () => {
      const response = await axiosInstance.get<AsyncMessageArchiveResponse>(
        "/new-api/async-message-dashboard/archive",
        {
          params: {
            page,
            per_page: perPage,
          },
        },
      );

      return response.data;
    },
    queryKey: [
      ...QueryKeys.Provider.AsyncMessageDashboard.ARCHIVE,
      page,
      perPage,
    ],
    enabled,
  });
};
